
       <div class="card-right">
        <div class="card-header">
        <h6>{{ cardData?.parsedObjectData?.['Service']}}</h6>
        <div class="pin-buttons">
            <button mat-button1 title="Click Pin to make it default" *ngIf="!checkDefaultPinService() && !cardData?.apiFailed" (click)="makeDefaultService(cardData?.parsedObjectData?.['Service'])" >
                <span><i class="fa-solid fa-thumbtack"></i></span></button>
       
             <button mat-button1 title="Default Service" *ngIf="checkDefaultPinService() && !cardData?.apiFailed">
                 <span><i class="fa-solid fa-thumbtack green"></i></span></button>
        </div>
        </div>
        <p>
        <span><strong>Service Info:</strong></span>
        <span>{{cardData?.parsedObjectData?.['Service Center Name'] }}</span>
        <span> {{cardData?.parsedObjectData?.['Phone']}}</span>
        <span>{{ cardData?.parsedObjectData?.['URL']}} </span></p>
        <p *ngIf="!cardData?.apiFailed">
        <span> <strong>Greeting:</strong></span> 
        <span>{{getGreeting(cardData?.parsedObjectData?.['Greeting'] ,  cardData?.parsedObjectData?.['Service Center Name'])}}</span>
    </p>
        <p *ngIf="!cardData?.apiFailed"><strong>Terminology for Employees:</strong>
        <span>{{cardData?.parsedObjectData?.['Title']}}</span>
    </p>
      </div> 


      